__webpack_require__.p = "/reports-time-based-details/referrals-hub/";